<template>
    <div class="row">
        <div class="col-md-12">
            <ul class="timeline">
                <li v-for="(list, index) in yearDetails" :key="index">
                    <div class="row timeline-movement timeline-movement-top">
                        <div class="timeline-badge timeline-future-movement">
                            <h4>
                                {{ formattedDate(list.describe[0].createdAt) }}
                            </h4>
                        </div>
                    </div>
                    <ul>
                        <li v-for="(describe, ind) in list.describe" :key="ind">
                            <div class="row timeline-movement">
                                <div class="col-sm-6 timeline-item">
                                    <div class="row">
                                        <div class="col-sm-11">
                                            <div class="timeline-panel credits">
                                                <div
                                                    v-if="describe.userId"
                                                    v-authenticated-image="
                                                        'users/' +
                                                        describe.user.avatar
                                                            .fileName
                                                    "
                                                    class="profile-pic"
                                                ></div>
                                                <div
                                                    v-else
                                                    class="profile-pic"
                                                    :style="{
                                                        'background-image':
                                                            'url(' +
                                                            require('@/assets/images/members/idenfo.png') +
                                                            ')',
                                                    }"
                                                ></div>
                                                <div class="timeline-details">
                                                    <div
                                                        v-if="describe.userId"
                                                        class="
                                                            float-left
                                                            timeline-details-username
                                                        "
                                                    >
                                                        <h5>
                                                            {{
                                                                describe.user
                                                                    .firstName
                                                            }}
                                                            {{
                                                                describe.user
                                                                    .lastName
                                                            }}
                                                        </h5>
                                                        <span>
                                                            {{
                                                                describe.user
                                                                    .role.title
                                                            }}</span
                                                        >
                                                    </div>
                                                    <div
                                                        v-else
                                                        class="
                                                            float-left
                                                            timeline-details-username
                                                        "
                                                    >
                                                        <h5>Idenfo</h5>
                                                        <span>
                                                            System
                                                            Activity</span
                                                        >
                                                    </div>
                                                    <div
                                                        class="
                                                            float-right
                                                            timeline-details-date
                                                        "
                                                    >
                                                        <p class="date-content">
                                                            {{
                                                                describe.createdAt
                                                                    | moment(
                                                                        'MMM D, YYYY h:mm a'
                                                                    )
                                                            }}
                                                        </p>
                                                    </div>
                                                    <component
                                                        :is="describe.type"
                                                        :details="describe"
                                                    ></component>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <timeline-image-preview-popup></timeline-image-preview-popup>
    </div>
</template>
<script>
import liveness from '@/components/timeline/Liveness.vue'
import comparison from '@/components/timeline/Comparison.vue'
import registration from '@/components/timeline/Registration.vue'
import name_screening_approved from '@/components/timeline/NameScreening.vue'
import name_screening_rejected from '@/components/timeline/NameScreening.vue'
import lock_alert from '@/components/timeline/LockAlert.vue'
import approve_alert from '@/components/timeline/ApproveAlert.vue'
import alert_on_boarding from '@/components/timeline/AlertOnBoarding.vue'
import manualOverwriteFace from '@/components/timeline/ManualOverwriteFace.vue'
import manualOverwriteLiveness from '@/components/timeline/ManualOverwriteLiveness.vue'
import cancel_alert_review from '@/components/timeline/CancelAlertReview'
import alert_triggered from '@/components/timeline/AlertTriggered'
import delta_alert_triggered from '@/components/timeline/DeltaAlertTriggered'
import delta_alert_on_boarding from '@/components/timeline/DeltaAlertOnboarding'
import periodic_review from '@/components/timeline/PeriodicReview'
import created_alert from '@/components/timeline/CreatedAlert'
import updatedNameScreening from '@/components/timeline/UpdatedNameScreening'
import timelineImagePreviewPopup from '@/components/popups/TimelineImagePreviewPopup.vue'
import viewedCustomerProfile from '@/components/timeline/ViewedCustomerProfile.vue'
import unlock_alert from '@/components/timeline/UnlockAlert.vue'
import initiated_simulation_against_customer from '@/components/timeline/InitiatedSimulationAgainstCustomer.vue'

export default {
    components: {
        liveness,
        comparison,
        registration,
        name_screening_approved,
        name_screening_rejected,
        lock_alert,
        approve_alert,
        alert_on_boarding,
        manualOverwriteLiveness,
        manualOverwriteFace,
        cancel_alert_review,
        alert_triggered,
        periodic_review,
        created_alert,
        updatedNameScreening,
        timelineImagePreviewPopup,
        viewedCustomerProfile,
        unlock_alert,
        initiated_simulation_against_customer,
        delta_alert_triggered,
        delta_alert_on_boarding,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        yearDetails: {
            type: Array,
            default: null,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {}, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        formattedDate(date) {
            if (
                this.$moment(date).format('MMM D, YYYY') ==
                this.$moment().format('MMM D, YYYY')
            ) {
                return 'Today'
            }
            return this.$moment(date).format('MMM D, YYYY')
        },
    }, // End of Component > methods
} // End of export default
</script>
